import * as React from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';

import {globalDispatchToPropsObject} from '../../store';
import * as logoIMG from '../images/logogray.png';
import {BoundedContainer} from '../util';

interface DispatchProps {
		logIn(request: AuthenticateRequest): Promise<Partial<UserState>>;
		unifiedLogIn(code: string, loginApi: string): Promise<Partial<UserState>>;
}

function mapDispatchToProps(dispatch: Dispatch<StudioState>): DispatchProps {
	const {logIn, unifiedLogIn} = globalDispatchToPropsObject;
	return {
				logIn: request => dispatch(logIn(request)),
				unifiedLogIn: (code, loginApi) => dispatch(unifiedLogIn(code, loginApi)),
	};
}

type Props = DispatchProps & RouteComponentProps<{}>;

class UnifiedLogin extends React.Component<Props> {
	constructor(props: Props, context: any) {
				super(props, context);
				const params = new URLSearchParams(props.location.search);

				if (params.has('code') && params.has('api')) {
					this.props.unifiedLogIn(
						params.get('code'),
						decodeURIComponent(params.get('api')),
					);
				}
	}

	public render() {
		return <BoundedContainer>
			<div className='login'>
				<img className='login-logo' src={logoIMG} />
								<div className='unified-login-message'>Logging in with Unified Login....</div>
			</div>
		</BoundedContainer>;
	}
}

export default connect<{}, DispatchProps, {}>
	(null, mapDispatchToProps)(UnifiedLogin);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-studio-index/UnifiedLogin.tsx